import { map } from 'rxjs/operators';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { GlobalService } from './global.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { RouterStateSnapshot } from '@angular/router';

@Injectable({
	providedIn: 'root'
})

export class LoginService {

  actionTokenURL = this._gS.service_url + 'saml/loginToken';

	validateSesion(token?, page?, project_id?) {
		let data = {
			token: token,
			page: page,
			project_id: project_id
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'saml/validate', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
		// if (token) {
		//   return this.http.get(this._gS.service_url + 'saml/validate', {
		//       params: new HttpParams()
		//         .set('token', token)
		//         .set('page', page)
		//         .set('project_id', project_id)
		//   })
		// } else {
		//   return this.http.get(this._gS.service_url + 'saml/validate', {
		//       params: new HttpParams()
		//         .set('page', page)
		//         .set('project_id', project_id)
		//   })
		// }

	}

	logout() {
		let data = {
			session_id: this._gS.session_token,
		}
		return this.http.post(this._gS.service_url + 'saml/logout', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	setRedirecUrl(state: RouterStateSnapshot) {
		localStorage.setItem('returnUrl', JSON.stringify(state.url));
  	}

	sendToken(email: string) {
		let data = {
			email: email,
		}
		return this.http.post(this._gS.service_url + 'saml/sendToken', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	sendTokenLogView(email: string) {
		let data = {
			email: email,
		}
		return this.http.post(this._gS.service_url + 'live_view/generateToken', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	validateLiveView(email: string, token: any, unit_id: any) {
		let data = {
			email: email,
			token: token,
			unit_id: unit_id 
		}
		return this.http.post(this._gS.service_url + 'live_view/validate_email', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getTokenLv() {
		return sessionStorage.getItem('lv-session');
	}

	removeSessionLv() {
		sessionStorage.removeItem('lv-session');
	}

	constructor(private _cookieService: CookieService, private http: HttpClient, public _gS: GlobalService) {

	}
}
